export default function initGatedAccessForm($) {
    $('#gated-access-form').submit(e => {
        e.preventDefault();

        const email = $('#email').val();
        const security = $('#gated_access_nonce').val();
        const pageID = $('#page-id').val();

        $.ajax({
            type: 'POST',
            url: ans.ajaxurl,
            dataType: 'json',
            data: {
                action: 'gated_access',
                email,
                security,
                pageID
            }
        }).done( (res) => {
           if(res.access_granted) {
               $('#gated-access-form').find('.sucess-text').addClass('visible');
               $('#gated-access-form').find('.error-text').removeClass('visible');
                window.location.reload();
           } else {
               $('#gated-access-form').find('.sucess-text').removeClass('visible');
               $('#gated-access-form').find('.error-text').addClass('visible');
           }
        }).fail( (res) => {
            $('#gated-access-form').find('.sucess-text').removeClass('visible');
            $('#gated-access-form').find('.error-text').addClass('visible');
        });
    });
}